"use client";

import type { z } from "zod";

import { CarouselDotButton, CarouselDotNavigation } from "@/common/components/carousel";
import { SafeHydrate, useMobile } from "@/common/helpers";

import type { validateItemForPackageCardSchema } from "../../../../offering/api/fetch-blood-test-packages-for-landing-page/fetch-blood-test-packages-for-landing-page.schema";

export function PackagesCarouselNavigation({
  packages,
}: {
  packages: z.infer<typeof validateItemForPackageCardSchema>[];
}) {
  const isMobile = useMobile();

  return (
    <SafeHydrate>
      <CarouselDotNavigation
        className="lg:mt-3"
        items={(selectedIndex) =>
          packages.slice(0, isMobile ? packages.length : packages.length - 3).map((_, index) => (
            <CarouselDotButton
              // biome-ignore lint/suspicious/noArrayIndexKey: Fine for carousel use case
              key={`packages-carousel-dot-${index}`}
              index={index}
              className="size-4 border-2 opacity-80 lg:size-5"
              active={Boolean(index === selectedIndex)}
              aria-label={`${index + 1}`}
            >
              <span />
            </CarouselDotButton>
          ))
        }
      />
    </SafeHydrate>
  );
}
